import { create } from "zustand";

const useShowJoinComHook = create((set) => ({
  isOpen: false, 
  open: () => set({isOpen: true}),
  close: () => set({isOpen: false})
}))

export default useShowJoinComHook